import {store} from "@/plugins/vuex";
import {SEPA_TABLE_NAME} from "@/modules/constants";
import EventBus from "@/plugins/event-bus";
import {ON_SEPA_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
import SepaService from "../SepaService";
import InventoryService from "@/modules/inventory/InventoryService";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    extraFilters: {},
    expand: 'created_at',
  }
};
export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      sale: getDefaultTableData(),
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${SEPA_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          ordering: ordering,
        }
      }
      data.expand = currentTableData.expand

      data.auction_uuid = currentTableData.sale.uuid

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      EventBus.$emit(ON_SEPA_TABLE_GET_TABLE_DATA, {params});
      commit('updateTableLoading', true);
      const response = await SepaService.getSepas(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering
        });
      }
      return response;
    },
    async updateTableSource({state}, {source, sale}) {
      state.tableSource = source;
      state.tableData[source].sale = sale;
    },
    async resetTable({state, dispatch}) {
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...defaultTableData
      };
      dispatch('getTableData');
    },
    async removeSepa({dispatch}, sepa) {
      let response = await SepaService.removeSepa(sepa.uuid);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
  },
  mutations: {
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {
      ...state.tableData[state.tableSource],
      ...payload
    },
  }
}
